import { useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { CostCentersListDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CostCentersPeopleAssignment } from 'modules/cost_centers/components/CostCentersPeopleAssignment'
import { CostCenterEmployeeList } from 'modules/cost_centers/components/Resources/Employees/CostCenterEmployeeList'

const CostCentersPeoplePage = () => {
  const { hasNewStructureEnabled } = useOutletContext<{
    hasNewStructureEnabled: boolean
  }>()

  const { loading, data } = useQuery(CostCentersListDocument, {
    fetchPolicy: 'no-cache',
    skip: hasNewStructureEnabled,
  })

  if (loading)
    return (
      <Box alignItems="center" justifyContent="center" height="full" width="full" flexGrow>
        <Loading />
      </Box>
    )

  const costCenters = data?.costCenters?.costCentersConnection?.edges.map((edge) => edge.node) ?? []

  return hasNewStructureEnabled ? (
    <CostCentersPeopleAssignment costCenters={costCenters} />
  ) : (
    <CostCenterEmployeeList costCenters={costCenters} />
  )
}

export default CostCentersPeoplePage
